export default "__VITE_ASSET__DMXnrB7w__"